import React, { useContext, useState } from 'react';
import classNames from 'classnames';
import { useTranslation } from 'react-i18next';
import Brand from '../../../layout/Brand/Brand';
import Navigation, { NavigationLine } from '../../../layout/Navigation/Navigation';
import User from '../../../layout/User/User';
import { adminRoutes } from '../../../menu';
import Card, { CardBody } from '../../../components/bootstrap/Card';
import Hand from '../../../assets/img/hand.png';
import HandWebp from '../../../assets/img/hand.webp';
import Icon from '../../../components/icon/Icon';
import Button from '../../../components/bootstrap/Button';
import useDarkMode from '../../../hooks/useDarkMode';
import Aside, { AsideBody, AsideFoot, AsideHead } from '../../../layout/Aside/Aside';
import AuthContext from '../../../contexts/authContext';
import Spinner from '../../../components/bootstrap/Spinner';

const DefaultAside = () => {
	const [doc, setDoc] = useState(
		localStorage.getItem('facit_asideDocStatus') === 'true' || false,
	);
	const { t } = useTranslation(['translation', 'menu']);
	const { darkModeStatus } = useDarkMode();

	const { isLoading } = useContext(AuthContext);

	return (
		<Aside>
			<AsideHead>
				<Brand />
			</AsideHead>
			<AsideBody>
				{isLoading ? (
					<div className='flex flex-col items-center mt-10'>
						<div className='p-3 w-100 d-flex justify-content-center align-items-center'>
							<Spinner className='text-white' size='lg' />
						</div>
						<p className='italic'>Loading Menus...</p>
					</div>
				) : (
					<div className='overflow-auto' id='aside'>
						{!doc && (
							<>
								<Navigation menu={adminRoutes} id='aside-demo-pages' />
							</>
						)}
						{doc && (
							<>
								<NavigationLine />
							</>
						)}
						{doc && (
							<Card className='m-3 '>
								<CardBody className='pt-0'>
									<img
										srcSet={HandWebp}
										src={Hand}
										alt='Hand'
										width={130}
										height={130}
									/>
									<p
										className={classNames('h4', {
											'text-dark': !darkModeStatus,
											'text-light': darkModeStatus,
										})}>
										{t('Everything is ready!')}
									</p>
									<Button
										color='info'
										isLight
										className='w-100'
										onClick={() => {
											localStorage.setItem('facit_asideDocStatus', 'false');
											setDoc(false);
										}}>
										{t('Demo Pages')}
									</Button>
								</CardBody>
							</Card>
						)}
					</div>
				)}
			</AsideBody>
		</Aside>
	);
};

export default DefaultAside;
